<script setup lang="ts">
import Badge from 'primevue/badge';
import MainMenuItems from '@/config/MainMenuItems';
import Menu from 'primevue/menu';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import logoUrl from '@/assets/1.png';

const route = useRoute();

const mainMenuItems = ref(MainMenuItems);
</script>
<template>
    <Menu
        :model="mainMenuItems"
        class="rounded-none transition-colors duration-200"
        :pt="{ root: { class: '!px-0' }, itemLink: { class: '!px-2' } }"
    >
        <template #item="{ item, props }">
            <router-link v-if="item.route" v-slot="{ navigate }" :to="item.route" custom>
                <a
                    v-ripple
                    class="flex items-center"
                    v-bind="props.action"
                    @click="navigate"
                    :class="{ 'bg-surface-100': route.path === item.route }"
                >
                    <span :class="item.icon" />
                    <span>{{ item.label }}</span>
                    <Badge v-if="item.badge" class="ml-auto" :value="item.badge" />
                </a>
            </router-link>
        </template>
    </Menu>
</template>